import { render, staticRenderFns } from "./CompositeProductCompositionColor.vue?vue&type=template&id=ecdc0804&"
import script from "./CompositeProductCompositionColor.vue?vue&type=script&lang=js&"
export * from "./CompositeProductCompositionColor.vue?vue&type=script&lang=js&"
import style0 from "./CompositeProductCompositionColor.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
